import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { CustomMeatballIcon } from '../../../theme/icons/CustomMeatballIcon';
import BatchesUpdateMoreInfo from './BatchesUpdateMoreInfo';
import { useDisclosure } from '@chakra-ui/react';
import { useCallback } from 'react';
import AlertDialogWrapper from '../../common/AlertDialogWrapper';
import useCancelBatch from '../../../hooks/useCancelBatch';
import ProcessNowModal from '../../modals/ProcessNowModal';
import { CustomViewIcon } from '../../../theme/icons/CustomViewIcon';
import { DownloadIcon, NotAllowedIcon, RepeatIcon } from '@chakra-ui/icons';
interface BatchUpdateInfo {
  id: string;
  name: string;
  status: string;
  scheduledAt?: string | null;
  errorsCsvUrl?: string | null;
}

interface CellData {
  row?: {
    original: BatchUpdateInfo;
  };
  original?: BatchUpdateInfo;
}

interface BatchesUpdateMenuProps {
  cell: CellData;
}

const BatchesUpdateMenu = ({ cell }: BatchesUpdateMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isCancelOpen,
    onOpen: onCancelOpen,
    onClose: onCancelClose,
  } = useDisclosure();
  const {
    isOpen: isProcessOpen,
    onOpen: onProcessOpen,
    onClose: onProcessClose,
  } = useDisclosure();
  const { cancelBatch } = useCancelBatch();

  const original: BatchUpdateInfo = cell?.row?.original ??
    cell?.original ?? {
      id: '',
      name: '',
      status: '',
    };

  const handleConfirmCancel = useCallback(async () => {
    try {
      await cancelBatch(original?.id);
    } finally {
      onCancelClose();
    }
  }, [cancelBatch, original?.id, onCancelClose]);

  return (
    <>
      <Menu>
        <MenuButton>
          <CustomMeatballIcon boxSize={6} color="secondaryDark" />
        </MenuButton>
        <MenuList>
          <MenuItem
            onClick={onOpen}
            _focus={{
              backgroundColor: 'lightGrey2',
            }}
          >
            <CustomViewIcon fontSize={18} mr={2} color="secondaryDark" />
            View Details
            <BatchesUpdateMoreInfo
              isOpen={isOpen}
              onClose={onClose}
              cell={cell}
            />
          </MenuItem>

          {original.status === 'scheduled' && (
            <MenuItem
              onClick={onCancelOpen}
              _focus={{
                backgroundColor: 'lightGrey2',
              }}
            >
              <NotAllowedIcon fontSize={18} mr={2} color="secondaryDark" />
              Cancel Scheduled Update
            </MenuItem>
          )}

          {original.status === 'scheduled' && (
            <MenuItem
              onClick={onProcessOpen}
              _focus={{
                backgroundColor: 'lightGrey2',
              }}
            >
              <RepeatIcon fontSize={18} mr={2} color="secondaryDark" />
              Update Now
            </MenuItem>
          )}

          {original.errorsCsvUrl !== null && (
            <MenuItem
              onClick={() => {
                window.open(original.errorsCsvUrl, '_blank');
              }}
              _focus={{
                backgroundColor: 'lightGrey2',
              }}
            >
              <DownloadIcon fontSize={18} mr={2} color="secondaryDark" />
              Download Errors CSV
            </MenuItem>
          )}
        </MenuList>
      </Menu>
      <AlertDialogWrapper
        isOpen={isCancelOpen}
        onClose={onCancelClose}
        onConfirm={handleConfirmCancel}
        title="Cancel Scheduled Update"
        body="Are you sure you want to cancel this scheduled update? You won't be able to undo this action."
        buttonText="Cancel Update"
      />
      <ProcessNowModal
        isOpen={isProcessOpen}
        onClose={onProcessClose}
        batchId={original?.id}
        batchName={original?.name}
        scheduledTime={original?.scheduledAt}
      />
    </>
  );
};

export default BatchesUpdateMenu;
